import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import PdfViewer from '../components/PdfViewer';

const PdfViewerPage = () => {
    const [isOpen, setIsOpen] = useState(false);

    const toggle = () => {
        setIsOpen(!isOpen);
    };

    return (
        <>
            <Navbar toggle={toggle} margin={true} type={false} lightTheme={true} />
            <PdfViewer />
        </>
    );
};

export default PdfViewerPage;
